<template>
  <div id="app">
    <app-header />
    <!--  class="slide" :class="{isHidden: visibleOn !== 1, isVisible: visibleOn === 1}" -->
    <app-sounds></app-sounds>
    <!--  class="slide" :class="{isHidden: visibleOn !== 2, isVisible: visibleOn === 2}" -->
    <app-backgrounds :class="{isHidden: visibleOn !== 2}"></app-backgrounds>
    <app-cookiespolicy :class="{isHidden: visibleOn !== 3}"></app-cookiespolicy>
    <app-footer></app-footer>

    <div id="age-cookies" class="hideaccept">
        <span>
            {{cookiepolicytext}} <a id="a-cookiespolicy" href="#" @click.prevent="cookiepolicy" target="_self">{{toread}}</a>.
        </span>
        <button id="accept-cookies" class="btn btn-primary btn-cookie" type="button">Accept</button>
    </div>
    <video id="video_background" autoplay loop preload="auto" volume="50" class="">
        <source src="" type="video/mp4">
    </video>
  </div>
</template>

<script>
    import Header from './components/links/Header.vue';
    import Sounds from './components/Sounds.vue';
    import Backgrounds from './components/Backgrounds.vue';
    import Cookiespolicy from './components/legaltexts/Cookiespolicy.vue';
    import Footer from './components/links/Footer.vue';

    export default {
        name: "app",
        components: {
            'app-header': Header,
            'app-sounds': Sounds,
            'app-backgrounds': Backgrounds,
            'app-cookiespolicy': Cookiespolicy,
            'app-footer': Footer
        },
        data() {
            return {
                visibleOn: 1,
                cookiepolicytext: 'This website uses cookies and other technologies to improve your experience on my sites. If you continue browsing, you accept the terms.',
                toread: 'Read the cookie policy.'
            };
        },
        methods: {
            cookiepolicy() {
                if(this.visibleOn == 1) {
                    $( "#main" ).hide( "slow" );
                } else if(this.visibleOn == 2) {
                    $( "#wallpapers" ).hide( "slow" );
                }
                $( "#cookiestext" ).show( "slow" );
                $( "button" ).blur();
                $( "#header" ).css({'background-color': 'rgb(82, 23, 81)'});
                $( ".options" ).css({'color': '#ffffff'});
                $( ".logo" ).css({'color': '#ffffff'});
                this.visibleOn = 3;
            }
        }
    };
</script>

<style>
    .isHidden{
        /*animation: slide-out 200ms ease-out forwards;*/
        display: none;
    }
    .isVisible {
        animation: slide-in 300ms ease-out forwards;
    }
    @keyframes slide-in {
        from {
            transform: translateY(-30px);
            opacity: 0;
        }
        to {
            transform: translateY(0);
            opacity: 1;
        }
    }
    @keyframes slide-out {
        from {
            transform: translateY(0px);
            opacity: 1;
        }
        to {
            transform: translateY(-30px);
            opacity: 0;
        }
    }
</style>



// WEBPACK FOOTER //
// src/App.vue